//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import veelgesteldeVragen from '~/graphql/queries/veelgesteldeVragen.gql';

export default {
  auth: false,
  apollo: {
    veelgesteldeVragen: {
      query: veelgesteldeVragen,
    },
  },
  data: () => ({
    openedDropdown: 0,
    veelgesteldeVragen: [],
  }),
  computed: {
    categories() {
      const categories = [];
      this.veelgesteldeVragen.forEach((v) => {
        v.categories.forEach((c) => {
          if (!categories.includes(c.name)) {
            categories.push(c.name);
          }
        });
      });
      return categories;
    },
  },
  methods: {
    veelgesteldeVragenVanCategorie(categorie) {
      return this.veelgesteldeVragen.filter(v => v.categories.some(c => c.name === categorie));
    },
  },
  head: () => ({
    title: 'Veelgestelde vragen',
  }),
};
